// The page loads bluebird 3.3.4 (see index.html), which replaces the global
// Promise but predates Promise.allSettled. CRA's react-app-polyfill/stable used
// to patch it back in; since that polyfill was dropped in the Vite migration we
// restore just this one method (used by third-party scripts like fbevents).
if (typeof Promise.allSettled !== 'function') {
  Promise.allSettled = function allSettled(promises) {
    return Promise.all(
      Array.from(promises).map((p) =>
        Promise.resolve(p).then(
          (value) => ({ status: 'fulfilled', value }),
          (reason) => ({ status: 'rejected', reason })
        )
      )
    )
  }
}
